module.exports = __webpack_public_path__ + "static/media/pin.6c4c3533.png";